export default {
  namespaced: true,
  state: () => ({
    data: [],
    columns: [],
  }),
  mutations: {
    setData: (state, payload) => {
      state.data = payload;
    },
    setColumns: (state, payload) => {
      state.columns = payload;
    },
  },
};
